<template>
  <div class="backend-board">
    <section class="top-wrap">
      <div class="main-title">看板</div>
      <div class="right">
        <div class="mRight10">
          <el-input
            v-model="searchText"
            size="small"
            placeholder="搜索看板名称"
            clearable
            @keyup.native.enter="search"
            @clear="search"
          >
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
        </div>
        <base-button type="primary" @click="showCreateStatistics">
          新建
        </base-button>
      </div>
    </section>
    <section class="main-wrap">
      <div v-if="!showTable" v-loading="!showTable" class="empty"></div>
      <BaseTable
        v-else
        ref="BaseTable"
        :tableHeight="tableHeight"
        :tableColumns="tableColumns"
        :tableData="filterData"
        :pageInfo="pageInfo"
        from="app"
      >
        <el-table-column
          v-for="(item, index) in tableColumns"
          :key="index"
          :prop="item.value"
          :label="item.label"
          :width="item.width"
          :fixed="item.fixed"
          :min-width="item.minWidth"
          :align="item.align"
          show-overflow-tooltip
        >
          <template v-slot:header>
            <span v-tip>{{ item.label }}</span>
          </template>
          <template slot-scope="scope">
            {{ _.get(scope.row, item.value) }}
          </template>
        </el-table-column>
        <template v-slot:table-suffix>
          <el-table-column prop="handle" label="操作" width="160">
            <template v-slot="scope">
              <el-button @click.stop="toEditBoard(scope.row)" type="text" size="mini">
                编辑
              </el-button>
              <el-button @click.stop="toCopyBoard(scope.row)" type="text" size="mini">
                复制
              </el-button>
              <el-button @click.stop="handleDelete(scope.row)" type="text" size="mini">
                删除
              </el-button>
            </template>
          </el-table-column>
        </template>
      </BaseTable>
    </section>
    <add-board-dialog ref="addBoard" :app-id="app.id" @submit="addBoard"></add-board-dialog>
  </div>
</template>

<script>
import BaseTable from "@/components/BaseComponents/Table"
import TableController from "@/views/Backend/Admin/Layout/mixin/TableController"
import { tableColumns, boardColors, boardIcons } from "./static"
import * as statisticsApi from "@/api/appManage/statistics"
import BaseButton from "@/components/UIComponents/Button"
import AddBoardDialog from "@/views/Backend/Admin/Display/Menu/AddBoardDialog"

export default {
  name: "backend-board",
  components: {
    AddBoardDialog,
    BaseTable,
    BaseButton
  },
  inject: ["app"],
  data() {
    return {
      tableColumns,
      boardColors,
      boardIcons,
      searchText: "",
      filterKeys: ["name"],
      boardList: [],
      filterData: [],
      pageInfo: {
        total: 1000,
        currentPage: 1,
        pageSize: 20
      },
      loadingItems: {
        data: true
      }
    }
  },
  mixins: [TableController],
  created() {
    this.refresh()
  },
  methods: {
    refresh() {
      this.loadingItems.data = true
      this.dialogVisible = false
      statisticsApi.getManageDashboardList(this.app.id).then(boardList => {
        this.boardList = boardList
        this.loadingItems.data = false
        this.filterData = this.boardList
        this.resetPageInfo(this.filterData)
      })
    },
    showCreateStatistics() {
      this.$refs.addBoard.open()
    },
    addBoard() {
      this.refresh()
      this.$message.success("操作成功")
    },
    search() {
      this.handleSearch({
        tableData: this.boardList,
        filterKeys: this.filterKeys,
        searchText: this.searchText
      })
    },
    handleDelete(row) {
      this.$confirm("此操作将永久删除该统计, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        statisticsApi.deleteDashboard(row.id).then(() => {
          this.refresh()
          this.$message.success("刪除成功")
        })
      })
    },
    toEditBoard(tableRow) {
      localStorage.setItem("board", JSON.stringify(tableRow))
      this.$router.push({
        name: "board-edit",
        query: { id: tableRow.id }
      })
    },
    //  复制看板
    toCopyBoard(tableRow) {
      statisticsApi.copyDashboard(tableRow.id).then(() => {
        this.refresh()
        this.$message.success("复制成功")
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.backend-board {
  .empty {
    height: 100%;
    width: 100%;
  }
  .right ::v-deep {
    .el-input-group__append {
      padding: 0 10px;
    }
  }
}
</style>
